import Swiper from 'swiper'
import { Pagination } from 'swiper/modules'

export default class TripleImage {
  constructor(el) {
    this.el = el
    this.swiper = null
    this.init()
  }

  init() {
    const container = this.el.querySelector('.triple-image--slider')
    if (!container) return

    // Swiper actif uniquement en mobile (< 992px) — le bloc slider est masqué en desktop
    const mq = window.matchMedia('(max-width: 991px)')

    const sync = () => {
      if (mq.matches && !this.swiper) {
        this.swiper = new Swiper(container, {
          modules: [Pagination],
          slidesPerView: 1,
          spaceBetween: 16,
          speed: 600,
          pagination: {
            el: container.querySelector('.swiper-pagination'),
            clickable: true,
          },
        })
      } else if (!mq.matches && this.swiper) {
        this.swiper.destroy(true, true)
        this.swiper = null
      }
    }

    sync()
    mq.addEventListener('change', sync)
  }
}
